// Objeto centralizado de permisos para uso en componentes
export const permissions = {
  WITHDRAWALS: {
    LIST: 'list_balance_company_commpix_integration',
    CREATE: 'create_withdrawal_company_commpix_integration',
  },
  STAFF: {
    LIST: 'index_company_company_users',
    CREATE: 'create_company_company_users',
    SHOW: 'show_company_company_users',
    UPDATE: 'update_company_company_users',
    DELETE: 'destroy_company_company_users',
    REINVITE: 'invite_company_company_users',
  },
  SALES_REPORT: {
    SALES_SUMMARIES: 'index_company_sales_summaries',
    STATISTICS: 'statistics_company_sales_summaries',
    SUMMARY: 'transactions.summary',
  },
  HISTORY_TRANSACTION: {
    PAYMENT_REQUESTS: 'index_company_payment_requests',
    TRANSACTIONS: 'transactions.transactions',
    VIEW_MY_TRANSACTIONS: 'view_my_transactions_company_payment_requests',
    ADMIN_PAYMENT_REQUESTS: 'index_admin_company_payment_requests',
  },
  REMOTE_PAYMENT: {
    ORDERS: 'index_company_orders',
    NEMIPAYTAG: 'payments.nemipaytag',
  },
  DINAMIC_PAYMENT: {
    CREATE: 'create_company_order_templates',
    LIST: 'index_company_order_templates',
    VIEW_DETAIL: 'update_company_order_templates',
  },
  SCAN_TO_PAY: {
    CREATE: 'create_company_orders',
    LIST: 'index_company_orders',
    SHOW_DETAIL: 'show_company_orders',
  },
  SUPPORT: {
    CREATE: 'create_company_supports',
    SUPPORT: 'support',
  },
  INTEGRATIONS: {
    UPDATE_CREDENTIALS_COMMPIX: 'update_credentials_company_commpix_integration',
    UPDATE_CREDENTIALS_MASSPAYMENTS: 'update_credentials_company_masspayments_integration',
    MANAGE_USER_MANTECA: 'manage_user_company_manteca_integration',
    UPDATE_CREDENTIALS_PVS: 'update_credentials_company_pvs_integration',
    INTEGRATIONS: 'integrations',
  },
  BOLEPIX: {
    LIST: 'list_bolepix_company_commpix_integration',
    CREATE: 'create_bolepix_company_commpix_integration',
    SHOW_DETAIL: 'show_bolepix_company_commpix_integration',
  },
  PAYINS_QR: {
    LIST: 'list_payin_company_masspayments_integration',
    CREATE: 'create_payin_company_masspayments_integration',
    SHOW_DETAIL: 'show_payin_company_masspayments_integration',
  },
  TRANSFERENCES: {
    LIST: 'index_company_transferences',
    SHOW_DETAIL: 'show_company_transferences',
  },
  BALANCE: {
    LIST: 'list_payouts_balance_company_masspayments_integration',
    CREATE: 'create_payout_company_masspayments_integration',
    SHOW_DETAIL: 'view_payout_company_masspayments_integration',
  },
  AUTHORIZATION_REQUIRED_PAYOUTS: {
    AUTHORIZATION_REQUIRED: 'authorization_required_payout_company_masspayments_integration',
  },
  PROCESS_PAYOUTS: {
    PROCESS: 'process_payout_company_masspayments_integration',
  },
  CANCEL_PAYOUTS: {
    CANCEL: 'cancel_payout_company_masspayments_integration',
  },
  PAYOUTS_CONFIGURATION: {
    CONFIGURE: 'configure_payout_authorization_company_masspayments_integration',
  },
  PENDING_PAYOUTS: {
    LIST: 'list_payouts_balance_company_masspayments_integration',
  },
  AUTHORIZE_PAYOUTS: {
    AUTHORIZE: 'authorize_payout_company_masspayments_integration',
  },
  DAILY_TRANSACTIONS_STATEMENT: {
    SHOW: 'idx_daily_txns_rpt_company_payment_requests',
  },
};

export const historyTransactionPermission = [
  permissions.HISTORY_TRANSACTION.PAYMENT_REQUESTS,
  permissions.HISTORY_TRANSACTION.TRANSACTIONS
];

export const salesReportPermission = [
  permissions.SALES_REPORT.SALES_SUMMARIES,
  permissions.SALES_REPORT.SUMMARY,
  permissions.SALES_REPORT.STATISTICS
];

export const remotePaymentPermission = [
  permissions.REMOTE_PAYMENT.ORDERS,
  permissions.REMOTE_PAYMENT.NEMIPAYTAG
];

export const dinamicPaymentPermission = [
  permissions.DINAMIC_PAYMENT.CREATE,
  permissions.DINAMIC_PAYMENT.LIST
];

//  Qrs
export const SCAN_TO_PAY_CREATE = permissions.SCAN_TO_PAY.CREATE;
export const scanToPayPermission = [
  permissions.SCAN_TO_PAY.CREATE,
  permissions.SCAN_TO_PAY.LIST,
  permissions.SCAN_TO_PAY.SHOW_DETAIL
];

export const staffPermissions = [
  permissions.STAFF.SHOW,
  permissions.STAFF.CREATE,
  permissions.STAFF.LIST,
  permissions.STAFF.UPDATE,
  permissions.STAFF.DELETE,
  permissions.STAFF.REINVITE
];

export const supportPermission = [
  permissions.SUPPORT.CREATE,
  permissions.SUPPORT.SUPPORT
];

export const commpixIntegrations = [
  permissions.INTEGRATIONS.UPDATE_CREDENTIALS_COMMPIX,
  permissions.INTEGRATIONS.INTEGRATIONS
];

export const masspaymentIntegrations = [
  permissions.INTEGRATIONS.UPDATE_CREDENTIALS_MASSPAYMENTS,
  permissions.INTEGRATIONS.INTEGRATIONS
];

export const mantecaIntegrations = [
  permissions.INTEGRATIONS.MANAGE_USER_MANTECA,
  permissions.INTEGRATIONS.INTEGRATIONS
];

export const pvsIntegrations = [
  permissions.INTEGRATIONS.UPDATE_CREDENTIALS_PVS,
  permissions.INTEGRATIONS.INTEGRATIONS
];
//  Withdrawals
export const PERM_LIST = permissions.WITHDRAWALS.LIST;
export const PERM_CREATE = permissions.WITHDRAWALS.CREATE;
export const withdrawalsPermission = [
  permissions.WITHDRAWALS.LIST,
  permissions.WITHDRAWALS.CREATE,
  'withdrawals'
];

export const bolepixPermissions = [
  permissions.BOLEPIX.LIST,
  permissions.BOLEPIX.CREATE
];

export const payinsQrPermissions = [
  permissions.PAYINS_QR.LIST,
  permissions.PAYINS_QR.CREATE
];

export const transferencesPermissions = [
  permissions.TRANSFERENCES.LIST
];

export const balancePermissions = [
  permissions.BALANCE.LIST,
  permissions.BALANCE.CREATE,
  permissions.BALANCE.SHOW_DETAIL
];

export const dailyTransactionsStatementPermissions = [
  permissions.DAILY_TRANSACTIONS_STATEMENT.SHOW
];

export const payoutsConfigurationPermissions = [
  permissions.PAYOUTS_CONFIGURATION.CONFIGURE
];

export const pendingPayoutsPermissions = [
  permissions.PENDING_PAYOUTS.LIST
];

